import * as IoC from 'typescript-ioc';
import { IntlShape } from 'react-intl';
import { withViewModel } from '../../../../../infrastructure/components/with-view-model';
import { GuidelinesFormPresentation } from './guidelines-form.presentation';
import GuidelinesFormVM from './guidelines-form.viewmodel';
import { OpenFrom } from '../../../../../tracking-service/tracking-values';
export interface IGuidlinesFormContainerProps {
    intl: IntlShape;
    isEditMode: boolean;
    handleEventNotesChange: (eventNotes: string, openFrom: OpenFrom) => Promise<boolean>;
    openFrom: OpenFrom;
    setEventNotes: (value: string) => void;
    getEventNotes: () => string;
    trackGuidelinesMixPanel: (openFrom: OpenFrom, dataSaved: boolean) => void;
    fetchEventNotes: () => Promise<void>;
}

const GuidelinesFormContainer = withViewModel(GuidelinesFormPresentation, async (props: IGuidlinesFormContainerProps) => {
    const guidelinesFormVM = IoC.Container.get<GuidelinesFormVM>(GuidelinesFormVM);
    guidelinesFormVM.initialize(props);
    await props.fetchEventNotes();
    return guidelinesFormVM;
});

export { GuidelinesFormContainer as GuidelinesForm };
